import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(Element);

import request from "@/utils/axios"
Vue.prototype.$request = request

import './assets/scss/index.scss' //グローバルCSSスタイル
import './assets/scss/common.scss' //グローバルCSSスタイル

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

router.afterEach((to, from) => {
  /* ルーティング変更でページタイトルを変更 */
  if (to.meta.title) {
    // 利用日選択、座席選択画面
    if(to.name=='datetime'&&to.query.booking_id||to.name=='seat'&&to.query.booking_id){
      document.title ='予約内容の変更｜小湊鐵道 指定席券'
    }
    else if(to.name=='changeCompleted'&&to.query.type==2){
      document.title ='任意の座席をキャンセル完了｜小湊鐵道 指定席券'
    }
    else if(to.name=='changeCompleted'&&to.query.type==3){
      document.title ='予約のキャンセル完了｜小湊鐵道 指定席券'
    }
    else{
      document.title = to.meta.title
    }
  }
})